// extracted by mini-css-extract-plugin
export default {"date_item":"DatesList_date_item__jK+HZ"};